import { MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { PATTERN } from "@/constants/pattern";
import { validator } from "@/utils/validator";

export const mockExamEditSchema = validator.object().shape({
  name: validator.string().trim().max(255).label("模擬試験名").required(),
  examDuration: validator.number().commas().autoTransformToHalfWidth().emptyToNull().integer().min(1).max(500).label("試験時間").required(),
  passingScore: validator
    .number()
    .commas()
    .autoTransformToHalfWidth()
    .emptyToNull()
    .min(1)
    .max(10000)
    .label("合格ラインとなる点")
    .required()
    .test("passing-score-decimal", "「合格ラインとなる点」は小数第1位まで入力してください。", (value) => {
      if (value == null) return true;

      return Number.isInteger(value * 10);
    })
    .test("passing-score-lt-total-score", "「合格ライン」は満点未満を入力してください。", function (value) {
      const { totalScore } = this.parent;
      if (value == null || totalScore == null) return true;
      return value < totalScore;
    }),
  totalScore: validator
    .number()
    .commas()
    .autoTransformToHalfWidth()
    .emptyToNull()
    .min(1)
    .max(10000)
    .label("満点")
    .required()
    .test("passing-score-decimal", "「満点」は小数第1位まで入力してください。", (value) => {
      if (value == null) return true;

      return Number.isInteger(value * 10);
    }),
  allowReferenceBooks: validator.boolean().default(false),
  allowCalculator: validator.boolean().default(false),
  allowClock: validator.boolean().default(false),
  internalMemo: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("社内メモ").notRequired(),
  spreadsheetUrl: validator
    .string()
    .trim()
    .emptyToNull()
    .max(500)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("模擬試験データのスプレッドシートURL")
    .required(),
});
